import { useMemo } from 'react';
import {
  useLocation,
  useNavigate,
  useSearchParams as useReactSearchParams,
} from 'react-router-dom';

export type AppRouter = {
  push: (path: string) => void;
  replace: (path: string) => void;
  back: () => void;
};

export const useRouter = (): AppRouter => {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      push: (path: string) => navigate(path),
      replace: (path: string) => navigate(path, { replace: true }),
      back: () => navigate(-1),
    }),
    [navigate]
  );
};

export const usePathname = (): string => useLocation().pathname;

export const useSearchParams = (): URLSearchParams => {
  const [searchParams] = useReactSearchParams();

  return searchParams;
};
